module.exports = __webpack_public_path__ + "static/scale-model-of-eldorado-resort-casino-in-reno-nevada-a5ae15c1314d11b53de73ad599b15be9.png";